import * as React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { GetQuery } from './Shared';

interface JobQuoteDetails {
    id: number;
    jobId: number;
    versionNumber: number;
    quoteNo: number;
    manualQuoteNumber: string;
    totalQuotedAmount: string;
    jobQuoteItems: JobQuoteItems[];
}

interface JobQuoteItems {
    itemIndex: number;
    id: number;
    item: string;
    itemId: number;
    isVoid: boolean;
    isWalkWay: boolean;
    unitOfMeasure: string;
    hirePeriod: number;
    hirePeriodWeeks: number;
    frequency: string;
    size: number;
    quantity: number;
    travelAmountFormatted: number;
    fuelSurchargeAmountFormatted: string;
    extraHours: number;
    amountFormatted: number;
    overhireRateFormatted: number;
    notes: string;
    quoteNote: string;  //max 20 chars to go on the quote under the item name
}

const JobQuoteHistoryData = () => {
    let navigate = useNavigate();
    const { id } = useParams();
    const [loading, setLoading] = React.useState(true);
    const [systemCompanyId, setSystemCompanyId] = React.useState(2);
    const [siteAddress, setSiteAddress] = React.useState("");
    const [jobQuotes, setJobQuotes] = React.useState<JobQuoteDetails[]>([]);
        
    React.useEffect(() => {
        window.scrollTo(0, 0);
        getData();
    }, []);

    const getData = async () => {
        const apiUrl = 'GetQuoteHistory?JobId=' + id;
        var result = await GetQuery(apiUrl);

        if (result.error) {
            toast.error("Error getting data!");
        } else {
            setJobQuotes(result.data.jobQuotes);
            setSiteAddress(result.data.siteAddress);
            setSystemCompanyId(result.data.systemCompanyId);
            setLoading(false);
        }
    }

    const goToQuote = () => {
        var url = "/job/" + id + "/quote";
        navigate(url);
    }

    const printJobQuote = (jobQuoteId: number) => {
        var reportName = systemCompanyId === 3 ? "JobRequest" : "JobQuote";

        var url = "/job/" + id + "/report/" + reportName + "/" + jobQuoteId;
        window.open(url, '_blank');      
    }

    let jobQuoteHeading = systemCompanyId === 3 ? "Print Job Request" : "Print Job Quote";

    const renderDetails = (
        <div className="marginTop10">
            <div className="makeitflexspacebetween">
                <h1>Quote History - {siteAddress}</h1>
                <button type="button" className="defaultbutton" onClick={goToQuote}>Back to Quote</button>
            </div>
            <div className="quoteHistoryTable">
                {jobQuotes.map(quote =>
                    <div key={quote.id} className="scheduleRow marginTop10 paddingFull10">
                        <h4>Version Number: {quote.versionNumber}</h4>
                        <div className="overflowHideVertical">
                            <table className="table table__large tableColours">
                                <thead>
                                    <tr>
                                        <th className="hidden">Id</th>
                                        <th></th>
                                        <th>Item</th>
                                        <th>Hire Period {systemCompanyId === 2 ? "(days)" : "(weeks)"}</th>
                                        <th className={systemCompanyId === 3 ? "" : "hidden"} >Maint.</th>
                                        <th className={systemCompanyId === 3 ? "hidden" : ""}>Void Size</th>
                                        <th>Quantity</th>
                                        <th className="textalignright">Travel ($)</th>
                                        <th className="textalignright">Fuel Surcharge ($)</th>
                                        <th className="textalignright">Extra Hours</th>
                                        <th className="textalignright">Amount ($)</th>
                                        <th className="textalignright">Overhire Rate ($)</th>
                                        <th>Notes</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {quote.jobQuoteItems.map((item, index) =>
                                        <tr key={index}>
                                            <td className="hidden">{item.id}</td>
                                            <td className="table__text--align">{index + 1}</td>
                                            <td className="table__text--align">{item.item}</td>
                                            <td className="table__text--align">{systemCompanyId === 2 ? item.hirePeriod : item.hirePeriodWeeks}</td>
                                            <td className={systemCompanyId === 3 ? "table__text--align" : "hidden"}>{item.frequency}</td>
                                            <td className={systemCompanyId === 3 ? "hidden" : "table__text--align"}>{item.isVoid ? item.size + " m2" : ""}</td>
                                            <td className="table__text--align">{item.quantity} {item.unitOfMeasure}</td>
                                            <td className="table__text--align textalignright">{item.travelAmountFormatted}</td>
                                            <td className="table__text--align textalignright">{item.fuelSurchargeAmountFormatted}</td>
                                            <td className="table__text--align textalignright">{item.extraHours}</td>
                                            <td className="table__text--align textalignright">{item.amountFormatted}</td>
                                            <td className="table__text--align textalignright">{item.overhireRateFormatted}</td>
                                            <td className="table__text--align">
                                                <div className="tooltipitem tooltipitem__left">{item.notes ? item.notes.substring(0, 20) + "... " : ""}
                                                    <span className="tooltipitemtext tooltipitemtext__left">{item.notes}</span>
                                                </div>
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                        <div>
                            <button className="defaultbutton" type="button" onClick={() => printJobQuote(quote.id)}>{jobQuoteHeading}</button>
                        </div>
                    </div>
                )}
            </div>
        </div>
    )

    let contents = loading
        ? <p><em>Loading...</em></p>
        : renderDetails;

    return (
        <div>
            {contents}
        </div>
    );

}

export default JobQuoteHistoryData;
